import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

/**
 * Fetches current organization details for the settings page.
 * Uses the `organization` query which is accessible to any authenticated member
 * (including ORG_ADMIN), unlike `organizationDetailAdmin` which is ADMIN-only.
 */
export const ORGANIZATION_SETTINGS = gql`
  query OrganizationSettings($id: ID!) {
    organization(id: $id) {
      _id
      name
      type
      tier
      description
      picture
      website
      isActive
      memberCount
      maxUsers
      effectiveMaxUsers
      seatUsage {
        used
        limit
        percentage
        status
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * Roster stats for the org info panel. ORG_ADMIN + ADMIN can access this.
 */
export const ORGANIZATION_ROSTER_STATS = gql`
  query OrganizationSettingsRosterStats($organizationId: ID!) {
    organizationRosterStats(organizationId: $organizationId) {
      totalEntries
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization($id: ID!, $input: UpdateOrganizationInput!) {
    updateOrganization(id: $id, input: $input) {
      _id
      name
      type
      description
      picture
      website
      isActive
      memberCount
      createdAt
      updatedAt
    }
  }
`;
